import { List, Stack, Title, Anchor } from "@mantine/core";
import { useTranslation } from "react-i18next";
import classes from "./QuestionList.module.css";

export interface QuestionListProps {
    questions: string[];
    onQuestionClick: (question: string) => void;
}

export const QuestionList = ({ questions, onQuestionClick }: QuestionListProps) => {
    if (questions.length === 0) {
        return null;
    }
    const { t } = useTranslation();
    return (
        <Stack gap="md">
            <Title order={6}>{t("followupQuestions")}</Title>
            <List>
                {questions.map((question, index) => (
                    <List.Item key={index} className={classes.listItem}>
                        <Anchor lineClamp={1} onClick={() => onQuestionClick(question)} size="sm" className={classes.anchor}>
                            {question}
                        </Anchor>
                    </List.Item>
                ))}
            </List>
        </Stack>
    );
};
